import { ColumnConfig } from '@/components/table/Table';
import { Badge } from '@/components';
import { Commerce } from '../models';
import { formatCommerceAddress, getCommerceCity } from '../utils';

const statusColors: Record<
  string,
  { backgroundColor: string; ballColor: string; textColor: string }
> = {
  ACTIVE: {
    backgroundColor: '#E8F5E9',
    ballColor: '#2E7D32',
    textColor: '#2E7D32',
  },
  CREATED: {
    backgroundColor: '#E3F2FD',
    ballColor: '#1976D2',
    textColor: '#1976D2',
  },
  INACTIVE: {
    backgroundColor: '#FFEBEE',
    ballColor: '#C62828',
    textColor: '#C62828',
  },
};

const statusLabels: Record<string, string> = {
  ACTIVE: 'Activo',
  CREATED: 'Creado',
  INACTIVE: 'Inactivo',
};

export const commercesTableColumns: ColumnConfig[] = [
  {
    field: 'name',
    label: 'Nombre',
    sortable: true,
  },
  {
    field: 'businessName',
    label: 'Nombre Comercial',
    sortable: true,
  },
  {
    field: 'externalId',
    label: 'ID Externo',
    sortable: false,
    render: (value: string) => value || '-',
  },
  {
    field: 'sellerIds',
    label: 'Seller ID (ML)',
    sortable: false,
    render: () => null,
  },
  {
    field: 'taxNumber',
    label: 'RUC',
    sortable: true,
  },
  {
    field: 'address',
    label: 'Dirección',
    sortable: false,
    render: (_value: unknown, rowData: Commerce) => {
      const address = formatCommerceAddress(rowData);
      const city = getCommerceCity(rowData);
      if (!address && !city) return '-';
      return (
        <div>
          <p className='text-sm text-gray-900'>{address || '-'}</p>
          {city && <p className='text-xs text-gray-500'>{city}</p>}
        </div>
      );
    },
  },
  {
    field: 'email',
    label: 'Email',
    sortable: false,
    render: (value: string) => value || '-',
  },
  {
    field: 'phone',
    label: 'Teléfono',
    sortable: false,
    render: (value: string) => value || '-',
  },
  {
    field: 'logisticOperator',
    label: 'Operador Logístico',
    sortable: false,
    render: () => {
      return null;
    },
  },
  {
    field: 'createdAt',
    label: 'Fecha de Creación',
    sortable: true,
    render: (value: string) => {
      if (!value) return '-';
      return new Date(value).toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
      });
    },
  },
  {
    field: 'status',
    label: 'Estado',
    sortable: true,
    render: (value: string) => {
      const colors = statusColors[value] || statusColors.CREATED;
      const label = statusLabels[value] || value;
      return <Badge value={label} {...colors} />;
    },
  },
];
